import styled from '@emotion/styled';
import { palette, shineOnMe, teaserFocusOn, teaserHoverOff, teaserHoverOn } from '../../css';

const StyledDiv = styled('div')(
    () => ({
        position: 'relative',
        overflow: 'hidden',
        paddingBottom: '100%', // square by default
    }),
    ({ _format: format, hover, hasPlaceholder, mouseFocus, noFocus, theme }) => {
        const formatStyle = {};
        switch (format) {
            case 'landscape':
                formatStyle.paddingBottom = '56.25%';
                break;
            case 'banner':
                formatStyle.paddingBottom = '25%';
                break;
            case 'portrait':
                formatStyle.paddingBottom = '133.33%';
                break;
            case 'square':
            default:
                formatStyle.paddingBottom = '100%';
                break;
        }
        const focusStyle = {};
        if (!noFocus && !mouseFocus) {
            focusStyle['a &'] = teaserFocusOn(theme, 'basic');
            focusStyle['a:focus &'] = teaserFocusOn(theme, 'focused');
        }
        let hoverStyle = {};
        if (hover && hover.off.length) {
            hoverStyle = teaserHoverOff(...hover.off);
        }
        if (hover && hover.on.length) {
            hoverStyle['a:hover &'] = teaserHoverOn(...hover.on);
        }
        let placeholderStyle = {};
        if (hasPlaceholder) {
            const shineColor = theme.teaser ? theme.teaser.shineColor : 'rgba(255, 255, 255, .025)';
            placeholderStyle = {
                ...shineOnMe(shineColor),
                backgroundColor: theme.teaser ? theme.teaser.bgColor : palette('primary', 'mainNav'),
            };
        }
        return {
            ...focusStyle,
            ...formatStyle,
            ...hoverStyle,
            ...placeholderStyle,
        };
    },
);

const img = {
    width: '100%',
    height: '100%',
    transition: 'opacity .1s, transform 1s',
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
};

const StyledImage = styled('img')(img);
const StyledBlurImage = styled('img')(img);

export { StyledDiv, StyledImage, StyledBlurImage };
